import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface OneStepCheckoutStyles {
  oneStepCheckoutEmailContainer: Styles
  oneStepCheckoutEmailLabel: Styles
  oneStepCheckoutEmail: Styles
  mandatoryIndicator: Styles
  newsletterCheckboxContainer: Styles
  newsletterCheckbox: Styles
  newsletterCheckboxLabel: Styles
  oneStepCheckoutEmailError: Styles
}

interface TextFieldStylesProps {
  isErrorTextField: boolean | undefined
}

export const useStyles = createUseStyles<OneStepCheckoutStyles, TextFieldStylesProps>((theme) => {
  return {
    oneStepCheckoutContainer: {
      marginTop: theme.calcUnit(theme.spacing.s3),
      marginBottom: theme.calcUnit(theme.spacing.s4),
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    oneStepCheckoutHeader: {
      padding: '16px 0',
      borderBottom: `${theme.calcUnit(1)} solid ${theme.colors.textFieldBorderColor}`,
      fontFamily: 'Roboto, Sans-seriff',
      fontWeight: 700,
      fontSize: theme.calcUnit(20),
      lineHeight: theme.calcUnit(24),
    },
    oneStepCheckoutEmailContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    oneStepCheckoutEmailLabel: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      fontSize: theme.calcUnit(14),
      lineHeight: theme.calcUnit(20),
    },
    oneStepCheckoutEmail: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      fontSize: theme.calcUnit(16),
      lineHeight: theme.calcUnit(24),
      paddingTop: theme.calcUnit(12),
      paddingBottom: theme.calcUnit(12),
      paddingLeft: theme.calcUnit(10),
      paddingRight: theme.calcUnit(10),
      borderWidth: theme.calcUnit(1),
      borderRadius: theme.calcUnit(4),
      borderColor: ({ isErrorTextField }) => (isErrorTextField ? '#FC1D1D' : theme.colors.textFieldBorderColor),
      marginTop: theme.calcUnit(theme.spacing.s2),
      color: theme.colors.webTextField,
      '&:focus': {
        outline: 'none',
      },
      '&::placeholder': {
        color: theme.colors.webTextFieldPlaceholder,
      },
    },
    oneStepCheckoutEmailError: {
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Roboto',
      fontStyle: 'italic',
      color: '#FC1D1D',
      fontWeight: 400,
      fontSize: theme.calcUnit(12),
      lineHeight: theme.calcUnit(20),

      '& svg': {
        marginRight: theme.calcUnit(5),
      },
    },
    mandatoryIndicator: {
      marginLeft: theme.calcUnit(theme.spacing.s1 / 2),
      color: 'red',
    },
    newsletterCheckboxContainer: {
      color: theme.colors.webFadedTextColor,
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.calcUnit(6),
      marginTop: theme.calcUnit(theme.spacing.s2),
    },
    newsletterCheckbox: {
      marginTop: theme.calcUnit(2),
      cursor: 'pointer',
    },
    newsletterCheckboxLabel: {
      fontFamily: 'Roboto',
      fontWeight: '400',
      fontSize: theme.calcUnit(12),
      lineHeight: theme.calcUnit(16),
      display: 'inline-block',
    },
  }
})
